/* Ela Teila — product tiles: the grid button says "View details" and opens the
 * product page instead of adding to cart. Quick view button is hidden in CSS. */
(function () {
  function label(root) {
    var items = (root || document).querySelectorAll(".product-item");
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var link = it.querySelector("a.product-item__aspect-ratio") || it.querySelector("a.product-item-meta__title");
      if (!link) continue;
      var href = link.getAttribute("href");
      if (!href) continue;
      var extras = it.querySelectorAll(".drawer--quick-buy, .popover--quick-buy");
      for (var k = 0; k < extras.length; k++) { extras[k].remove(); }
      var btns = it.querySelectorAll(".product-item__quick-form button, .product-item__quick-buy-button");
      for (var j = 0; j < btns.length; j++) {
        var b = btns[j];
        if (b.getAttribute("data-et-cta")) continue;
        b.removeAttribute("is");
        b.removeAttribute("aria-controls");
        var c = b.cloneNode(true);
        c.setAttribute("data-et-cta", href);
        c.setAttribute("type", "button");
        if (b.parentNode) b.parentNode.replaceChild(c, b);
        var t = c.querySelector(".loader-button__text") || c;
        t.textContent = (window.etTileCtaLabel || "View details");
        c.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          window.location.href = this.getAttribute("data-et-cta");
        }, true);
      }
    }
  }
  function init() {
    label(document);
    if (window.MutationObserver) {
      new MutationObserver(function () { label(document); }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();

/* -------------------------------------------------------------------------
   ELA TEILA 2026-09-07. HOME, sekcija image_with_text_pNwj6P
   ("DETAILS EITHER HOLD, OR THEY DON'T.").

   DU DALYKAI, abu tik TELEFONE, desktope viskas lieka kaip buvo:

   1) Pirma eilute "For petite dogs, small details are never just small."
      nerodoma. Apvyniojam i <span class="et-lead-line">, o slepia
      custom-mobile-an.css.

   2) Eilute lauziama po "natural and", kad butu:
         "...where comfort feels natural and"
         "every detail has a reason to be there."
      Idedam <br class="et-mobile-br">, kuri desktope custom-mobile-an.css
      paslepia (display:none ant <br> panaikina ir pati luzi).

   KODEL PER JS, O NE PER CSS AR TURINI:
   sekcijos tekstas yra VIENAS <p>, o eilutes viduje atskirtos <br><br>.
   Teksto mazgo CSS pasiekti negali, o <br> iraseti i sekcijos turini
   reikstu, kad jis atsirastu ir desktope. Turinys NEKEICIAMAS - tik
   papildomas elementais, kurie desktope niekur nesimato.
   ------------------------------------------------------------------------- */
(function () {
  function ilgasTekstas(p) {
    var n, ilgiausias = null;
    for (var i = 0; i < p.childNodes.length; i++) {
      n = p.childNodes[i];
      if (n.nodeType !== 3) continue;
      if (!ilgiausias || (n.nodeValue || "").length > (ilgiausias.nodeValue || "").length) ilgiausias = n;
    }
    return ilgiausias;
  }

  function wrap() {
    var sec = document.querySelector('[id*="__image_with_text_pNwj6P"]');
    if (!sec) return;
    var ps = sec.querySelectorAll(".image-with-text__text-wrapper p");
    for (var i = 0; i < ps.length; i++) {
      var p = ps[i];

      /* 1) pirma eilute i <span class="et-lead-line"> */
      if (!p.getAttribute("data-et-lead")) {
        var first = p.firstChild;
        if (first && first.nodeType === 3 && /never just small/i.test(first.nodeValue || "")) {
          var span = document.createElement("span");
          span.className = "et-lead-line";
          var node = first, nbr = 0;
          while (node) {
            var next = node.nextSibling;
            if (node.nodeType === 1 && node.tagName === "BR") {
              nbr++;
              if (nbr > 2) break;
            } else if (node !== first) {
              break;
            }
            span.appendChild(node);
            node = next;
          }
          p.insertBefore(span, p.firstChild);
          p.setAttribute("data-et-lead", "1");
        }
      }

      /* 2) luzis po "natural and" */
      if (!p.getAttribute("data-et-br")) {
        var tn = ilgasTekstas(p);
        if (tn) {
          var t = tn.nodeValue || "";
          var m = t.match(/natural and\s/);
          if (m) {
            var pjuvis = m.index + m[0].length;
            var likutis = tn.splitText(pjuvis);
            var br = document.createElement("br");
            br.className = "et-mobile-br";
            likutis.parentNode.insertBefore(br, likutis);
            p.setAttribute("data-et-br", "1");
          }
        }
      }
    }
  }

  if (document.readyState !== "loading") wrap();
  else document.addEventListener("DOMContentLoaded", wrap);
})();
